import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtils } from '../utils/httpUtils';
import { ExecutionQTestData } from '../model/execution';

@Injectable({
  providedIn: 'root'
})
export class ExecutionQTestDataMultipleService {

  readonly baseUrl = `${environment.qualificatesUrl}/executionQTestDataMultiple`;
  constructor(private http: HttpClient) { }

  updateDataMultiple(idExecution: number, idExecutionTest: number, data: ExecutionQTestData): Observable<any> {
    const url = `${this.baseUrl}/${idExecution}/${idExecutionTest}`;
    return this.http.put(url, data).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }
}
